import * as React from 'react';
import { Element, scroller } from 'react-scroll';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from '../../node_modules/redux';
import { withRouter } from 'react-router';

import userActions from '../user/userActions';
import authActions from '../auth/authActions';

import HomePageAssessment from './HomePageAssessment';
import HomePageAssessmentBottom from './HomePageAssessmentBottom';
import { Page } from '../components/common';
import { SectionLeft, SectionMain, SectionRight } from '../components/sections';
import Button from '../components/buttons/Button';
import {
	HomeownersIconFixedAmount,
	HomeownersIconFlexible,
	HomeownersIconLowerRates,
	HomeownersIconPickBeneficiaries,
	HomeownersIconPortable,
	HomeownersIconQuick,
	IconArrowDown,
	LogoFirstCanadian
} from '../components/icons';
import HomeownersHomeFlipCard from './HomeownersHomeFlipCard';
const scorLogoSrc = require('../assets/images/logo-scor.png');

interface Props {
	actions: any;
	history: any;
	currentUser: UserDetails;
	referrerName: string;
	match: any;
}
interface State {
	accordionOpenIndex: number | undefined;
}
class HomeonwersHomePage extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			accordionOpenIndex: undefined,
		};
	}

	componentWillMount() {
		document.body.classList.add('page-homeowners');
	}

	componentDidMount() {
		if (this.props.currentUser.isAuthenticated) {
			if ( this.props.currentUser.role !== undefined) {
				if ( this.props.currentUser.role[0] !== 'Customer' ) {
					if (this.props.currentUser.role.some(r => r === 'Adjudicator')) {
						return this.props.history.push('/admin/adjudication');
					} else {
						return this.props.history.push('/admin');
					}
				} 
				else if (!this.props.currentUser.hasBeenDirected) {
					this.props.actions.doneDirect(this.props.currentUser);
					return this.props.history.push('/user');			
				} 
			} 
		}
		const referralCode = 'Homeowners';
		this.props.actions.setReferralCode(referralCode);
	}

	componentWillUnmount() {
		document.body.classList.remove('page-homeowners');
	}

	onAltCtaClick = () => {
		let topOffset = 15;
		const navbar = document.querySelector('.navbar-wrapper.fixed-top');

		if (navbar) {
			topOffset += navbar.clientHeight;
		}

		scroller.scrollTo('homePageAssessment', {
			duration: 300,
			smooth: true,
			offset: -topOffset
		});
	}

	onAccordionClick = (accordionOpenIndex: number) => {
		if (this.state.accordionOpenIndex === accordionOpenIndex) {
			this.setState({ accordionOpenIndex: undefined });
		}
		else {
			this.setState({accordionOpenIndex});
		}
	}

	render() {
		return (
			<Page>
				<Helmet>
					<meta charSet="utf-8"/>
					<meta
						name="description"
						content={`Simple. Direct. Affordable. Discover your life insurance options in just 10 minutes and apply ` +
						`for up to $1 million in coverage to protect your family and your mortgage.`}
					/>
					<title>Mosaic Life - Simple & Afforadable Life Insurance | Homeowners</title>
				</Helmet>
				<header className="page-hero page-hero-homeowners page-hero-lg">
					<div className="page-hero-content">
						<div className="container">
							<div className="row">
								<div className="col-md-5 text-light d-flex flex-column justify-content-center">
									<div>
										<h1 className="page-hero-title page-title-display mb-0 mb-md-2">
											Term life insurance for Canadian homeowners
										</h1>
										<p className="mb-0 page-hero-lead-lg max-read-width mt-1 mb-3 strong">
											Protect your mortgage with a term policy in just 10 minutes.
										</p>
										<Button
											className="btn-primary btn-primary-inverse my-3 page-hero-cta-alt"
											onClick={this.onAltCtaClick}
										>
											Get started
											<IconArrowDown className="ml-2" />
										</Button>
									</div>
								</div>
								<div className="col-md-6 offset-md-1 mt-3 mt-md-0 px-0 d-flex flex-column justify-content-center">
									<Element name="homePageAssessment" />
									<SectionRight columns={12} sectionClassName="pr-0">
										<HomePageAssessment />
									</SectionRight>
								</div>
							</div>
						</div>
					</div>
				</header>
				<div className="container">
					<section className="section-main my-4 my-md-6">
						<div className="section">
							<h2>Mosaic Life: A Better Type of Insurance</h2>
							<p>
								Mosaic Life term insurance is a better way to protect your mortgage than the creditor insurance your lender offers.{' '}
								<strong>Check out the differences below:</strong>
							</p>
						</div>
						<HomeownersHomeFlipCard
							title="Lower Rates"
							icon={<HomeownersIconLowerRates className="flip-icon-comparison" />}
							primaryChildren={
								`Mosaic Life is able to offer lower rates by skipping the expensive brokers and instead dealing directly with you. 
								Mosaic Life coverage starts as low as $6 per month (and your premium remain fixed for the entire term of your policy).`
							}
							secondaryChildren={`For most people, creditor life insurance is more expensive than term life insurance.`}
							isOpened={this.state.accordionOpenIndex === 0}
							onCollapseClick={() => this.onAccordionClick(0)}
						/>
						<HomeownersHomeFlipCard
							title="Fixed coverage amount"
							icon={<HomeownersIconFixedAmount className="flip-icon-comparison" />}
							primaryChildren={
								`With Mosaic Life, your benefit amount doesn’t decrease.`
							}
							secondaryChildren={
								`With mortgage insurance, your benefit amount decreases as you pay down your mortgage (while your premium stays the same).`
							}
							isOpened={this.state.accordionOpenIndex === 1}
							onCollapseClick={() => this.onAccordionClick(1)}
						/>
						<HomeownersHomeFlipCard
							title="You choose the beneficiary"
							icon={<HomeownersIconPickBeneficiaries className="flip-icon-comparison" />}
							primaryChildren={
								`With Mosaic Life, you choose who receives the benefit (for example, your spouse or kids).`
							}
							secondaryChildren={`With mortgage insurance, if you die, the benefit is paid directly to the mortgage lender. `}
							isOpened={this.state.accordionOpenIndex === 2}
							onCollapseClick={() => this.onAccordionClick(2)}
						/>
						<HomeownersHomeFlipCard
							title="Portable"
							icon={<HomeownersIconPortable className="flip-icon-comparison" />}
							primaryChildren={
								`With Mosaic Life, your coverage remains in force if you switch mortgage lenders (or if you pay off your mortgage).`
							}
							secondaryChildren={
								`With mortgage insurance, if you change your lender to get a better rate, you’ll have to reapply for coverage 
								(likely at a higher rate because you’ll be older).`
							}
							isOpened={this.state.accordionOpenIndex === 3}
							onCollapseClick={() => this.onAccordionClick(3)}
						/>
						<HomeownersHomeFlipCard
							title="Flexible"
							icon={<HomeownersIconFlexible className="flip-icon-comparison" />}
							primaryChildren={
								`With Mosaic Life, it’s easy to add or decrease coverage as your life circumstances change 
								(e.g., if you have a kid or pay off the mortgage).`
							}
							secondaryChildren={`With mortgage insurance, the maximum coverage you can have is your mortgage amount outstanding.`}
							isOpened={this.state.accordionOpenIndex === 4}
							onCollapseClick={() => this.onAccordionClick(4)}
						/>
						<HomeownersHomeFlipCard
							title="Quick and easy"
							icon={<HomeownersIconQuick className="flip-icon-comparison" />}
							primaryChildren={
								`With Mosaic Life, if you’re generally healthy, you can get up to $1 million of coverage in just 10 minutes, entirely online.`
							}
							secondaryChildren={
								`Mortgage insurance requires you to meet in person with your lender or broker, manually fill out paperwork, 
								and possibly undergo a medical exam.`
							}
							isOpened={this.state.accordionOpenIndex === 5}
							onCollapseClick={() => this.onAccordionClick(5)}
						/>
					</section>
				</div>
				<div className="mt-4 mt-md-0 pt-md-6 landing-section">
					<div className="landing-section-img homeowners-section-img-01 landing-section-img-right" />
					<SectionLeft columns={8} sectionClassName="section-lg">
						<h2 className="mb-3">How Mosaic Life Works</h2>
						If you're young & healthy (the best time to buy life insurance), getting protection from Mosaic Life is simple:
						<ol className="custom-ol">
							<li>
								<div className="custom-ol-content">
									Choose a term and coverage amount (if you're unsure, <a href="/quote/B/about-you">we can help</a>).
								</div>
							</li>
							<li>
								<div className="custom-ol-content">Answer some quick lifestyle and health questions.</div>
							</li>
							<li>
								<div className="custom-ol-content">Get an instant decision and sign up.</div>
							</li>
						</ol>
						<p>
							Once you're covered, if you die during the term of your protection, your loved ones will receive your
							coverage amount.
						</p>
						<p>
							You can apply for up to $1 million of coverage, and it's easy to add or cancel policies if your needs change.
							If you change your mind during the first 30 days, you can cancel your policy and get a full refund.
						</p>
						<Button to="/faq" className="btn-outline-primary mt-3">
							Learn more
						</Button>
					</SectionLeft>
				</div>
				<section className="mt-4 mt-md-6 container d-none d-lg-block">
					<h2 className="mb-3">Why Choose Mosaic Life</h2>
					<div className="row row-x-1">
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container" onTouchStart={(e) => e}>
								<div className="flipper">
									<h3 className="front">Convenient and easy</h3>
									<div className="back">
										Most insurers require you to provide blood and urine samples and can take weeks to issue a policy.
										With Mosaic Life, you can get coverage in 10 minutes just by answering some lifestyle and health
										questions online.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Direct</h3>
									<div className="back">
										We’ve cut out the middlemen to give you an experience that’s free of hefty fees, commissions, and complexity.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-lg-3 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Team Canada</h3>
									<div className="back">Mosaic Life is proudly for Canadians, by Canadians.</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Affordable</h3>
									<div className="back">
										By skipping pricey broker commissions and taking insurance online, we’re able to offer $1 million of coverage for as little as $1/day.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-lg-3 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Guaranteed rates</h3>
									<div className="back">
										Your premiums are set for the term of your policy. Even if you get sick during your policy term,
										your premiums will not change.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Relevant</h3>
									<div className="back">
										We launched Mosaic Life out of our own need for protection. We've reimagined how life insurance
										should work&mdash;100% online, totally flexible, no brokers, simple.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Cancel anytime (with money-back guarantee)</h3>
									<div className="back">
										You can cancel your policy at any time and for any reason. If you cancel in the first 30 days, we
										will give you a full refund of your premium.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-lg-3 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">No fees</h3>
									<div className="back">
										Besides your monthly premium, there are no additional fees to obtain coverage.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Flexible</h3>
									<div className="back">
										We offer a range of terms and coverage amounts to meet your specific needs. You can have up to $1
										million in total coverage across as many policies as you would like.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-lg-3 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Insurance you can trust</h3>
									<div className="back">
										We try to be honest, transparent, and helpful. Your privacy is important to us.
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<SectionMain sectionClassName="mt-4 mt-md-6 section-lg">
					<div className="row align-items-center">
						<div className="col-md-5 col-lg-4 text-center">
							<LogoFirstCanadian className="landing-section-logo landing-section-logo-fc" />
						</div>
						<div className="col-md-7 col-lg-8 mt-4 mt-md-0">
							<p>
								Mosaic Life policies are underwritten by First Canadian Insurance Corporation, a life insurer based in Edmonton that has
								provided protection to over 1 million Canadian families.  First Canadian has been around for over 30 years and is rated
								A (with stable outlook) by A.M. Best, the leading ratings agency for insurance companies.
							</p>
						</div>
					</div>
					<div className="row align-items-center mt-4 mt-md-5">
						<div className="col-md-5 col-lg-4 text-center">
							<img src={scorLogoSrc} alt="The logo of SCOR (The Art & Science of Risk)" className="landing-section-logo landing-section-logo-scor" />
						</div>
						<div className="col-md-7 col-lg-8 mt-4 mt-md-0 order-md-first">
							<p>
								Mosaic Life is also backed by SCOR, one of the world’s largest reinsurers and a leader in the creation
								of innovative risk management solutions for insurance companies. SCOR has been around for almost 50
								years and is rated A+ (with stable outlook) by A.M. Best.
							</p>
						</div>
					</div>
				</SectionMain>
				<section className="mt-4 mt-md-6 section section-lg bg-secondary text-light">
					<div className="container">
						<HomePageAssessmentBottom />
					</div>
				</section>
			</Page>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		currentUser: state.auth.currentUser,
		referrerName: state.user.referrerName
	};
}

function mapDispatchToProps(dispatch: any) {
	const actions = {...authActions, ...userActions};
	return {
		actions: bindActionCreators(actions, dispatch),
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomeonwersHomePage));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landing/HomeownersHomePage.tsx